import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import PauseIcon from "@mui/icons-material/Pause";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import AcUnitIcon from "@mui/icons-material/AcUnit";
import StarRateIcon from "@mui/icons-material/StarRate";
import StarOutlineIcon from "@mui/icons-material/StarOutline";
import StarIcon from "@mui/icons-material/Star";
import StarPurple500Icon from "@mui/icons-material/StarPurple500";
import CelebrationIcon from "@mui/icons-material/Celebration";
// import StarRateIcon from "@mui/icons-material/StarRate";
import ToggleOffIcon from "@mui/icons-material/ToggleOff";
import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ScatterPlotIcon from "@mui/icons-material/ScatterPlot";
import { colorThemes } from "../Constants/constants";
const Timer = ({
  id,
  taskIndex,
  tasks,
  setTasks,
  colorMode,
  totalTime,
  totalSavedTime,
  totalBooster,
  totalBreakTime,
  setTotalTime,
  setTotalSavedTime,
  setTotalBooster,
  setTotalBreakTime,
  isSoundOn,
  isTaskHighlighed,
  wsoundTimer,
  initialUserInteraction,
  setInitialUserInteraction,
  currentThemeName,
}) => {
  const customBorder = "none";
  const iconStyle = {
    padding: "0px",
    width: 25,
    height: 25,
    color: colorMode ? "black" : "white",
  };
  const iconStyleCustom = {
    padding: "0px",
    width: 25,
    height: 25,
    color: colorMode ? "#aeaeae" : "white",
  };
  const themeColors = colorThemes[currentThemeName];
  // const playSound = (soundName) => {
  //   if (isSoundOn && initialUserInteraction) {
  //     const audio = new Audio(soundName); // Replace with your sound file path
  //     audio.play();
  //   }
  // };
  const wsoundCall = (remainingTime, snoozeTimer) => {
    if (remainingTime <= parseInt(wsoundTimer) && remainingTime > 1) {
      // Play wsound sound when remaining time is less than 60 seconds
      // playSound(beep);
    }
    if (remainingTime === 121) {
      // Play wsound sound when remaining time is less than 60 seconds
      // playSound(taskLessTimeAlert);
    }
    if (remainingTime === 1) {
      // Play wsound sound when remaining time is less than 60 seconds
      // playSound(FailedTask);
    }

    if (remainingTime < -5 && snoozeTimer <= 0 && remainingTime % 5 == 0) {
      // playSound(beep);

    }
  };

  if (tasks[taskIndex].isTaskRunning) {
    isSoundOn &&
      wsoundCall(tasks[taskIndex].remainingTime, tasks[taskIndex].snoozeTimer);
  }

  if (
    tasks[taskIndex].taskName.toLowerCase().startsWith("break") &&
    tasks[taskIndex].remainingTime < -5 &&
    Math.abs(tasks[taskIndex].remainingTime) % 20 === 0 &&
    tasks[taskIndex].isTaskRunning
  ) {
    // playSound(FailedTask);
  }

  if (
    !tasks[taskIndex].taskName.toLowerCase().startsWith("break") &&
    tasks[taskIndex].remainingTime < -5 &&
    Math.abs(tasks[taskIndex].remainingTime) % 120 === 0 &&
    tasks[taskIndex].isTaskRunning
  ) {
    // playSound(negativebeep);
  }

  const totalSeconds = tasks[taskIndex].remainingTime;
  const minutes =
    totalSeconds < 0
      ? Math.ceil(totalSeconds / 60) // Use Math.ceil for negative values to handle rounding correctly
      : Math.floor(totalSeconds / 60);

  const seconds = Math.abs(totalSeconds % 60); // Take absolute value of seconds to avoid negative seconds

  const formatTime = (time) => {
    return time < 10 ? `0${time}` : time;
  };

  const displayTime = () => {
    if (totalSeconds < 0) {
      return `-${formatTime(Math.abs(minutes))}:${formatTime(seconds)}`;
    } else {
      return `${formatTime(minutes)}:${formatTime(seconds)}`;
    }
  };

  const handleTimerToggle = () => {
    if (!initialUserInteraction) {
      setInitialUserInteraction(true);
    }
    if (!tasks[taskIndex].isTaskRunning) {
      // playSound(startTask);
    }
    // else{
    //     playSound(startTask)
    // }
    setTasks((prevTasks) =>
      prevTasks.map((prevTask) =>
        prevTask.id === tasks[taskIndex].id
          ? { ...prevTask, isTaskRunning: !tasks[taskIndex].isTaskRunning }
          : prevTask
      )
    );
  };

  const calculateTaskEfficiency = (time, intensity = 20) => {
    if (time <= 1) return 0;

    const maxTime = 30; // Maximum task time in minutes
    const minTime = 2; // Minimum task time in minutes

    // Constrain time within min and max bounds
    const boundedTime = Math.max(minTime, Math.min(time, maxTime));

    // Calculate score inversely proportional to task time, adjusted by intensity
    const calculatedScore =
      ((maxTime - boundedTime) / (maxTime - minTime)) * intensity;
    return Math.round(calculatedScore * 100) / 100; // Rounded to 2 decimal places
  };

  const calculateTaskTimeEfficiency = (task) => {
    const { estimatedTaskTime, remainingTime } = task;
    const completionTime = estimatedTaskTime - remainingTime;
    let scoreBonus = 0;

    // Bonus or penalty based on completion time conditions
    const highCompletionThreshold = 0.25 * estimatedTaskTime; // Adjust to make the bonus threshold more specific
    if (remainingTime > 0 && completionTime >= highCompletionThreshold) {
      scoreBonus += 1; // Increased bonus if task is completed significantly under estimated time
    } else if (completionTime < 0) {
      scoreBonus -= 2; // Increased penalty if task time exceeded
    }

    return scoreBonus;
  };

  const giveMeTaskScore = (task) => {
    const intensityVar = 2; // Adjusted intensity to match the scoring structure
    const baseScore = calculateTaskEfficiency(
      task.estimatedTaskTime / 60,
      intensityVar
    );

    // Apply the score bonus/penalty only if it's not a "break" task
    if (task.taskName.toLowerCase() !== "break") {
      return baseScore + calculateTaskTimeEfficiency(task);
    }

    // For "break" tasks, return only the efficiency score
    return calculateTaskTimeEfficiency(task);
  };

  const handleEndTask = () => {
    setTasks((prevTasks) =>
      prevTasks.map((prevTask) =>
        prevTask.id === tasks[taskIndex].id
          ? {
              ...prevTask,
              isTaskRunning: false,
              isCompleted: true,
              isTaskOverdue: tasks[taskIndex].remainingTime < 0,
              complitionTime:
                tasks[taskIndex].estimatedTaskTime -
                tasks[taskIndex].remainingTime,
              taskScore: giveMeTaskScore(tasks[taskIndex]),
            }
          : prevTask
      )
    );

    if (!tasks[taskIndex].taskName.toLowerCase().startsWith("break")) {
      setTotalTime(
        totalTime +
          (tasks[taskIndex].estimatedTaskTime - tasks[taskIndex].remainingTime)
      );
      totalSavedTime + tasks[taskIndex].remainingTime > 0 &&
        setTotalSavedTime(totalSavedTime + tasks[taskIndex].remainingTime);
      setTotalBooster(
        totalBooster +
          (tasks[taskIndex].boosterCount ? tasks[taskIndex].boosterCount : 0)
      );
    } else {
      setTotalBreakTime(totalBreakTime + tasks[taskIndex].estimatedTaskTime);
    }
    // playSound(DoneTask);
  };

  const removeItem1 = () => {
    if (!tasks[taskIndex].taskName.toLowerCase().startsWith("break")) {
      setTotalTime(
        totalTime -
          (tasks[taskIndex].estimatedTaskTime - tasks[taskIndex].remainingTime)
      );
    }

    setTasks((prevTasks) =>
      prevTasks.filter((prevTask) => prevTask.id !== tasks[taskIndex].id)
    );
  };

  return (
    // main list item
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        maxWidth: "90vw", // Use viewport width instead of fixed pixels
        width: "100%",
        // backgroundColor: colorMode ? "#e9e9e9" : "#4a4a4a",
        // backgroundColor:
        //   isTaskHighlighed &&
        //   tasks[taskIndex].isTaskRunning &&
        //   tasks[taskIndex].remainingTime < 0
        //     ? "flashing"
        //     : "normal",
        borderRadius: "10px",
        marginBottom: "14px",
        padding: "8px",
        border: customBorder, // Add a black border with 1px width
        // overflowX: 'auto', // Enable horizontal scrolling if needed
        boxShadow: "2px 2px 4px rgba(0, 0, 0, 0.1)", // Add shadow (adjust values as needed)
        "--background-color": themeColors.listItemColor,
      }}
      className={
        isTaskHighlighed &&
        tasks[taskIndex].isTaskRunning &&
        tasks[taskIndex].remainingTime < 20 &&
        tasks[taskIndex].remainingTime > 0 &&
        tasks[taskIndex].snoozeTimer < 1
          ? "flashing"
          : isTaskHighlighed &&
            tasks[taskIndex].isTaskRunning &&
            tasks[taskIndex].remainingTime < 0 &&
            tasks[taskIndex].snoozeTimer < 1
          ? "overduenormal"
          : "normal"
      }
      key={id}
    >
      {/* play pause */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "38px", // Set the width of the circle
          height: "38px", // Set the height equal to the width to maintain a perfect circle
          borderRadius: "50%", // Makes the element a circle by using border-radius
          backgroundColor: "white", // Change the background color as needed
          marginLeft: "5px",
          border: customBorder, // Add a black border with 1px width
          backgroundColor: colorMode ? "white" : "black",
        }}
      >
        {tasks[taskIndex].isCompleted && (
          <>
            <StarIcon style={iconStyleCustom}></StarIcon>
            {/* <CelebrationIcon style={iconStyleCustom}></CelebrationIcon> */}
          </>
        )}
        {!tasks[taskIndex].isCompleted && (
          <>
            {!tasks[taskIndex].isTaskRunning ? (
              <PlayArrowIcon onClick={handleTimerToggle} style={iconStyle}>
                Start
              </PlayArrowIcon>
            ) : (
              <PauseIcon onClick={handleTimerToggle} style={iconStyle}>
                Pause
              </PauseIcon>
            )}
          </>
        )}
      </div>
      {/* timer  */}
      <div
        style={{
          width: "50px", // Set the width of the circle
          height: "30px", // Set the height equal to the width to maintain a perfect circle
          borderRadius: "25px", // Makes the element a circle by using border-radius
          backgroundColor: colorMode ? "white" : "black",
          marginLeft: "0px",
          border: customBorder, // Add a black border with 1px width
          marginLeft: "1px", // Reduce the left margin here
          marginRight: "1px", // Reduce the right margin here
          cursor: "pointer",
        }}
        onClick={() => {
          setTasks((prevTasks) =>
            prevTasks.map((prevTask) =>
              prevTask.id === tasks[taskIndex].id
                ? {
                    ...prevTask,
                    snoozeTimer:
                      tasks[taskIndex].remainingTime < 30
                        ? tasks[taskIndex].snoozeTimer < 600
                          ? tasks[taskIndex].snoozeTimer + 150
                          : tasks[taskIndex].snoozeTimer
                        : 0,
                  }
                : prevTask
            )
          );
        }}
      >
        <div style={{ paddingTop: "3px" }}>
          <b
            style={{
              fontSize: "12px", // Reduced size for tight spaces
              // fontFamily: "'Cinzel', serif",
              letterSpacing: "1px", // Compact layout
              textAlign: "center", // Improves alignment
              color:
                totalSeconds > 0
                  ? colorMode
                    ? "#626262"
                    : "white"
                  : tasks[taskIndex].isTaskRunning
                  ? "#e17878" //red
                  : colorMode
                  ? "#626262"
                  : "white",
            }}
          >
            {displayTime()}
          </b>
          {/* <span style={{ fontSize: '8px' }}> /{estimatedTaskTime}</span> */}
        </div>
      </div>
      {/* Task Name */}
      <div
        style={{
          fontFamily: "Lora",
          fontSize: "1rem",
          width: "200px", // Set the width of the circle
          //height: '38px', // Set the height equal to the width to maintain a perfect circle
          borderRadius: "5px", // Makes the element a circle by using border-radius
          backgroundColor: colorMode ? "white" : "black", // Change the background color as needed
          marginLeft: "0px",
          textAlign: "left",
          minHeight: "38px", // Set a minimum height
          maxHeight: "auto", // Allow the div to grow in height
          overflow: "hidden", // Hide overflow content
          margin: "3px",
          border: customBorder, // Add a black border with 1px width
          marginLeft: "1px", // Reduce the left margin here
          marginRight: "1px", // Reduce the right margin here
        }}
      >
        <p
          style={{
            padding: "8px",
            margin: "1px",
            overflowWrap: "break-word",
            wordWrap: "break-word",
            color: colorMode ? "black" : "white",
            fontWeight: 500,
          }}
        >
          {tasks[taskIndex].taskName}
        </p>
      </div>
      {/* Complete or close  */}
      <div>
        {!tasks[taskIndex].isCompleted && (
          <>
            <CheckCircleIcon onClick={handleEndTask} style={iconStyle}>
              End
            </CheckCircleIcon>
          </>
        )}
        {tasks[taskIndex].isCompleted && (
          <>
            <CancelIcon
              onClick={() => {
                removeItem1();
              }}
              style={iconStyle}
            >
              Remove
            </CancelIcon>
          </>
        )}
      </div>
    </div>
  );
};
export default Timer;
